import React from "react";
import {
  CREATE_STATUS_PHASE_CREATING,
  CREATE_STATUS_PHASE_ERROR,
  CREATE_STATUS_PHASE_SUCCESS,
} from "./actionItemCreatePhases";

/**
 * Status banner while adding an action item (voice, selection, or typed text).
 *
 * @example
 * <ActionItemCreateFeedback feedback={{ phase: "creating", message: "Saving action item…" }} />
 */
const ActionItemCreateFeedback = ({ feedback }) => {
  if (!feedback?.phase) return null;

  const isCreating = feedback.phase === CREATE_STATUS_PHASE_CREATING;
  const isSuccess = feedback.phase === CREATE_STATUS_PHASE_SUCCESS;
  const isError = feedback.phase === CREATE_STATUS_PHASE_ERROR;
  const className = [
    "action-item-create-feedback",
    isCreating ? "action-item-create-feedback--creating" : "",
    isSuccess ? "action-item-create-feedback--success" : "",
    isError ? "action-item-create-feedback--error" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={className} role="status" aria-live="polite">
      {isCreating ? (
        <span className="action-item-create-feedback__spinner" aria-hidden="true" />
      ) : (
        <span className="action-item-create-feedback__icon" aria-hidden="true">
          {isSuccess ? "✓" : "!"}
        </span>
      )}
      <span className="action-item-create-feedback__text">
        {String(feedback.message || "").trim() || "Working…"}
      </span>
    </div>
  );
};

export default ActionItemCreateFeedback;
